export { defaultConnectorsModalConfig, version, walletRegistryUrl } from './config.js';
export { Web3Auth } from './modalManager.js';
export * from '@web3auth/no-modal';
